import React, { useMemo } from 'react';
import ListItem, { ListItemContent, ListItemImage } from '../../../elements/ListItem';
import NotificationsBubble from '../../../elements/NotificationsBubble';
import RightChevron from '../../../elements/RightChevron';
import styles from './ChatSessionListItem.module.scss';

function ChatSessionListItem(props) {
    const { className = '', chatSession, notifications } = props,
        unreadMessages = useMemo(() => notifications.filter((notif) => _.includes(chatSession.sessions, _.get(notif, 'content.data.chatId'))).length, [notifications, chatSession]);

    return (
        <ListItem tagName="div" className={[className, styles.ChatSessionListItem].join(' ')}>
            <ListItemImage className={styles.avatar} src={chatSession.avatarUrl} altSrc={'img/no_avatar.png'} round>
                <NotificationsBubble>{unreadMessages}</NotificationsBubble>
            </ListItemImage>
            <ListItemContent href={['.', chatSession.id].join('/')}>
                <div className="text name">{[chatSession.name, chatSession.surname].filter(Boolean).join(' ')}</div>
                <div className="text ">{chatSession.position}</div>
                <div className="text ">{chatSession.company}</div>
            </ListItemContent>
            <RightChevron />
        </ListItem>
    );
}

export default ChatSessionListItem;
